<div class="" fxFlex="100">

  <!-- TOP BACKGROUND -->

    <div fxLayout="column" fxFlex="100" class="fondo">
      <div class="toolbar primary ">
        <span><h3 class="titulo_s">{{'CONSULTARENCUESTA.TITULO' | translate }}</h3></span>
      </div>


      <ng-container *ngIf="version3">
        <div class="" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="!inputStart">
          <mat-form-field class="institutoStart" appearance="outline" fxFlex="100">
            <mat-label>{{'CONSULTARENCUESTA.SELE_AN_ENCU' | translate }}</mat-label>
            <mat-select>
              <mat-option *ngFor="let ano of anosSelect" [value]="ano.ano" (click)="encuestaConsul(ano.ano)">
                {{ano.ano}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="inputStart">

          <mat-form-field class="instituto" appearance="outline" fxFlex="33">
            <mat-label>{{'CONSULTARENCUESTA.SELE_AN_ENCU' | translate }}</mat-label>
            <mat-select>
              <mat-option *ngFor="let ano of anosSelect" [value]="ano.ano" (click)="encuestaConsul(ano.ano)">
                {{ano.ano}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="cargando2==2">
            <mat-form-field class="filtro"  appearance="outline" fxFlex="33">
              <mat-label>{{'CONSULTARENCUESTA.FILTRO_TI_EMPR_TOKEN' | translate }}</mat-label>
              <input matInput matInput (keyup)="apply2Filter($event.target.value)" placeholder="{{'CONSULTARENCUESTA.SELECCIONFILTRO' | translate }}" >
            </mat-form-field>
            <div class="btnDowload" fxFlex="33">
              <button mat-raised-button color="primary" (click)="exportTable2();">{{'CONSULTARENCUESTA.BOTON_DESCARGA_EXCEL' | translate }}</button>
            </div>
          </ng-container>
        </div>
        <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="space-evenly stretch" fxLayoutGap="10px" fxLayoutGap.xs="0" style="padding-bottom: 8% !important;">
          <ng-container *ngIf="cargando2==1">
            <div fxLayout="column" fxLayoutAlign="space-between center">
              <mat-spinner class="cargando" ></mat-spinner>
              <h1 class="textoC" >{{'CONSULTARENCUESTA.CARGANDO' | translate }}</h1>
            </div>
          </ng-container>
          <ng-container *ngIf="cargando2==2">
            <div class="" fxLayout="column" >
<div class="example-container mat-elevation-z8" id="scroolPrueba">
  <table id="TablaResultadosEncuestas2" mat-table [dataSource]="dataSource2"  >
    <ng-container [matColumnDef]="column" *ngFor="let column of displayed5Columns;" >
      <th mat-header-cell *matHeaderCellDef class="lftBrd"><div class="tamanoTh" fxLayout="row" fxLayoutAlign="center center">{{column}} </div></th>
      <td mat-cell *matCellDef="let element" class="lftBrd"><div class="" fxLayout="row" fxLayoutAlign="center center">{{element[column]}}</div></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayed5Columns; sticky: true" ></tr>
    <tr mat-row *matRowDef="let row; columns: displayed5Columns;"></tr>

  </table>

</div>

  <mat-paginator class="tamañoPagin" style-paginator  [pageSize]="10" showFirstLastButtons [showTotalPages]="3" [pageSizeOptions]="[50, 100, 500, 1000]" [length]="dataSource2.data.length"></mat-paginator>
            </div>
          </ng-container>

        </div>
      </ng-container>

    </div>
  </div>
